<template>
  <div :class="classNames">
    <div
      class="rating-stars__star"
      v-for="(unit, index) in units"
      :key="index">
      <div class="rating-stars__container">
        <div class="rating-stars__star-mask" />
        <div
          class="rating-stars__unit"
          :style="{ transform: `scaleX(${unit})`}" />
      </div>
    </div>
  </div>
</template>

<script>
import bemBlockModifiers from "/utils/bem-block-modifiers";
const MAX_MARK = 5;

const getUnits = (mark) => {
  const units = [];
  for (let i = 0; i < MAX_MARK; i++) {
    if (Math.floor(mark) > i) {
      units[i] = 1;
    } else if (Math.ceil(mark) <= i) {
      units[i] = 0;
    } else {
      units[i] = parseFloat((mark - i).toFixed(1));
    }
  }
  return units;
};

export default {
  props: {
    modifiers: {
      type: Array,
      default: null
    },
    extraClasses: {
      type: String,
      default: null
    },
    mark: {
      type: Number,
      default: MAX_MARK,
      validator: value => value >= 0 && value <= MAX_MARK
    }
  },

  data() {
    return {
      classNames: bemBlockModifiers("rating-stars", this.modifiers, this.extraClasses),
      units: getUnits(this.mark)
    };
  }
};
</script>

<style lang="scss">
.rating-stars {
  $root: &;

  display: flex;
  align-items: center;

  &__star {
    position: relative;

    width: 100%;

    background-color: $light-grey;

    &:not(:last-child) {
      margin-right: 5%;
    }
  }

  &__container {
    width: 100%;
    padding-top: 100%;
  }

  &__star-mask {
    position: absolute;
    /* stylelint-disable unit-blacklist */
    top: rem(-1px);
    right: rem(-1px);
    bottom: rem(-1px);
    left: rem(-1px);
    /* stylelint-enable unit-blacklist */
    z-index: 2;

    background-image: url(~@images/rating-stars/rating-star-mask.svg);
    background-size: contain;
  }

  &__unit {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    width: 100%;
    height: 100%;

    background-color: $green;

    transform-origin: left;
  }

  &--smartbanner {

    #{$root}__star-mask {
      background-image: url(~@images/rating-stars/rating-star-mask-smartbanner.svg);
    }
  }
}
</style>
